import React, { useState } from 'react';
import { TextToolTip } from '../toolTip';
import { FindLoad, Images } from 'utils';
import { MinLoader } from '../loader';

export const ApproveOrDeny = ({ item, changeStatusAction, handleChangeStatus, selectedItem }) => {
  const loadingStatus = FindLoad(changeStatusAction);

  return (
    <div className='flex' style={{ gap: '4px' }}>

      {(loadingStatus?.length  && selectedItem === item?.id) ?
        <MinLoader
          margin={'0'}
          style={
            {
              width: '24px',
              height: '24px',
              padding: '2px',
            }
          }
          position={'relative'}
          color={'#43BA4D'}
        />
        :
        <>
          <TextToolTip
            onClick={() => {
              handleChangeStatus(item, 'approve');
            }}
            content={'Approve'}
            placement='left'
            showTooltip
            arrow
            text={
              <img
                src={Images.checkGreen}
                alt='checkGreen'
                style={{ width: '100%', height: '100%' }}
              />
            }
            wrapperStyles={{
              width: '24px',
              height: '24px',
              padding: '2px',
            }}
          />
          <TextToolTip
            onClick={() => {
              handleChangeStatus(item, 'deny');
            }}
            content={'Deny'}
            placement='right'
            showTooltip
            arrow
            text={
              <img
                src={Images.clear}
                alt='checkGreen'
                style={{ width: '100%', height: '100%' }}

              />
            }
            wrapperStyles={{
              width: '24px',
              height: '24px',
              padding: '2px',
            }}
          />
        </>
      }
    </div>
  );
};

